import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    const { id } = payload || {}
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_SPONSORSHIP_UNBLOCK, {
      pathParams: { id },
    })
  },
  method: 'PATCH',
  format() {
    return {}
  },
  parse(raw = {}) {
    if (!raw.success) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to unblock sponsorship',
        data: null,
      }
    }

    return {
      statusCode: 200,
      message: 'Sponsorisation débloquée',
      data: raw.data,
    }
  },
}
